import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { changeDeal } from 'bundles/apex/deals/show/store/deal/actions';

import CreateModal from 'bundles/apex/vouchers/creation_modal';
import EmptyState from './empty_state';
import Voucher from './voucher';

export function VoucherTab({ changeDeal, deal, vouchersPath }) {
  const [showModal, setShowModal] = useState();

  return (
    <React.Fragment>
      {deal.voucher
        ? <Voucher/>
        : <EmptyState onClick={() => setShowModal(true)} />
      }

      <CreateModal
        deal={deal}
        path={vouchersPath}
        show={showModal}
        onCancel={() => setShowModal(false)}
        onSave={changes => changeDeal({ ...changes })}
      />
    </React.Fragment>
  );
}

VoucherTab.propTypes = {
  changeDeal: PropTypes.func.isRequired,
  deal: PropTypes.shape({
    voucher: PropTypes.object,
  }).isRequired,
  vouchersPath: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
  vouchersPath: state.paths.vouchers,
});

const mapDispatchToProps = {
  changeDeal,
};

export default connect(mapStateToProps, mapDispatchToProps)(VoucherTab);
